import React from 'react';
import { CtaClickLabel, sendCtaClickEvent } from '../../tracking';
import { CtaButton } from '../CtaButton';
import { EarlyAccessDialog } from '../EarlyAccessDialog';
import { GetStartedDialog } from '../GetStartedDialog';

export const SignupButton = ({
  text,
  variant,
  location,
  size
}: {
  text?: string | React.ReactNode;
  variant?: 'contained' | 'outlined';
  size?: 'small' | 'medium' | 'large';
  location?: CtaClickLabel;
}) => {
  const cta = text || 'Request early access';
  const v = variant || 'contained';
  const s = size || 'large';
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <>
      <CtaButton
        size={s}
        variant={v}
        style={{
          marginBottom: '6px',
          fontWeight: 700,
          height: '48px'
        }}
        onClick={() => {
          sendCtaClickEvent({ label: location || 'content' });
          setDialogOpen(true);
        }}
      >
        {cta}
      </CtaButton>
      <EarlyAccessDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

export const SignupButtonWithChoice = ({
  text,
  variant,
  location
}: {
  text?: string | React.ReactNode;
  variant?: 'contained' | 'outlined';
  location?: CtaClickLabel;
}) => {
  const cta = text || 'Request early access';
  const v = variant || 'contained';
  const [dialogOpen, setDialogOpen] = React.useState(false);

  return (
    <>
      <CtaButton
        size="large"
        variant={v}
        style={{
          marginBottom: '6px',
          fontWeight: 700,
          height: '48px'
        }}
        onClick={() => {
          sendCtaClickEvent({ label: location || 'content' });
          setDialogOpen(true);
        }}
      >
        {cta}
      </CtaButton>
      <GetStartedDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
